import React, {createContext, useContext} from 'react'
import {NodeType} from '../../../../../Utils/Constant/FlowConstants'

export type AddNodeBetweenEdgesFn = (
  nodeType: NodeType,
  source: string,
  target: string,
  position: {x: number; y: number}
) => void

type DragDropContextValue = {
  addNodeBetweenEdges?: AddNodeBetweenEdgesFn
}

const DragDropContext = createContext<DragDropContextValue>({})

export const useFlowDragDrop = () => useContext(DragDropContext)

export const FlowDragDropProvider: React.FC<{
  addNodeBetweenEdges?: AddNodeBetweenEdgesFn
  children: React.ReactNode
}> = ({addNodeBetweenEdges, children}) => {
  return (
    <DragDropContext.Provider value={{addNodeBetweenEdges}}>
      {children}
    </DragDropContext.Provider>
  )
}


